import React, { Component } from 'react';
import { get, has } from "lodash"
import { withStepsState } from "../../../shared/containers/containerStepsState"
import StepControl from "../stepControl"
import { isCurrentStep, buildStepClassName, updateOpenStepState } from "../../../shared/services/service.step"
import { steps } from "../../../shared/static.steps"
import locales from "../../../content.json";
import ButtonFill from "../../../shared/items/controls/buttonFill"
import styles from './firstPageQuestionA.module.scss'
import "./../../../shared/services/service.step.scss"

class FirstPageQuestionA extends Component {
  constructor() {
    super();

    this.state = {
      isOpenFirstPageQuestionA: false,
    }
  }

  componentDidMount() {
    if (isCurrentStep(this.props.currentIndex, steps.firstPageQuestionA) && !this.state.isOpenFirstPageQuestionA)
      this.setState({ isOpenFirstPageQuestionA: true })
  }

  componentDidUpdate(prevProps) {
    const { currentIndex, onSetStepData, data } = this.props
    const { isOpenFirstPageQuestionA } = this.state
    const params = {
      currentIndex: currentIndex,
      prevIndex: prevProps.currentIndex,
      stepIndex: steps.firstPageQuestionA,
      isOpen: isOpenFirstPageQuestionA,
      handleChange: this.handleChangeOpen.bind(this),
    }

    if (isOpenFirstPageQuestionA && !has(data, ["firstPageQuestionA"]))
      onSetStepData("firstPageQuestionA")

    updateOpenStepState({ params })
  }

  handleChangeOpen(state) {
    this.setState({
      isOpenFirstPageQuestionA: state,
    })
  }

  render() {
    const { currentIndex, data, onUpdateStepData } = this.props
    const { isOpenFirstPageQuestionA } = this.state
    const params = {
      className: "firstPageQuestionA",
      currentIndex: currentIndex,
      stepIndex: steps.firstPageQuestionA,
    }

    return isOpenFirstPageQuestionA ?
      <div className={buildStepClassName({ params })} style={{ padding: "0" }}>
        <div className={styles.firstPageQuestionA_wrapper}>
          <div className={styles.firstPageQuestionA}>
          <div className={styles.firstPageQuestionA_description}>
            {locales[window.userLang].firstPageQuestion_description}
          </div>
          <div className={styles.firstPageQuestionA_title}>
           {locales[window.userLang].firstPageQuestionA_title}
          </div>
          <div className={styles.firstPageQuestionA_image}>
          <div className={styles.firstPageQuestionA_labels}>
            <div className={styles.firstPageQuestionA_label}>{locales[window.userLang].firstPageQuestionA_label_1}</div>
            <div className={styles.firstPageQuestionA_label}>{locales[window.userLang].firstPageQuestionA_label_2}</div>
            <div className={styles.firstPageQuestionA_label}>{locales[window.userLang].firstPageQuestionA_label_3}</div>
            <div className={styles.firstPageQuestionA_label}>{locales[window.userLang].firstPageQuestionA_label_4}</div>
          </div>
            <div className={styles.firstPageQuestionA_text}>
              <div className={styles.firstPageQuestionA_textBefore}>{locales[window.userLang].firstPageQuestionA_textBefore}</div>
              <div className={styles.firstPageQuestionA_textAfter}>{locales[window.userLang].firstPageQuestionA_textAfter}</div>
            </div>
          </div>

          <StepControl>
            <ButtonFill 
              onClick={() => {
                onUpdateStepData.bind(this, "sex", "value", "female")();
                this.props.onToNextStep();
              }}>
              {locales[window.userLang].firstPageQuestionA_button}
            </ButtonFill>
          </StepControl>

          </div>
        </div>
      </div>
      : null
  }
}

export default withStepsState(FirstPageQuestionA);